module.exports = __webpack_public_path__ + "static/media/logo.8ee3b6f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo.png
// module id = 551
// module chunks = 0